import { useState, ReactNode } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

type Props = {
  children: ReactNode;
};

export const AdvancedOptionsDataColumnReport = ({ children }: Props) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <Accordion
      expanded={expanded}
      onChange={(_, isExpanded) => setExpanded(isExpanded)}
      elevation={0}
      sx={{
        borderRadius: '16px !important',
        overflow: 'visible !important',
        '&:before': {
          display: 'none',
        },

        '&.Mui-expanded .MuiAccordionSummary-root': {
          borderRadius: '16px',
          margin: '10px 0',
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ArrowForwardIosIcon sx={{ width: 15 }} />}
        sx={{
          borderRadius: '16px',
          flexDirection: 'row-reverse',

          '&.Mui-expanded': {
            minHeight: '10px',
          },

          '& .MuiAccordionSummary-content.Mui-expanded': {
            margin: '0',
          },
          '&.Mui-expanded .MuiAccordionSummary-expandIconWrapper': {
            transform: 'rotate(90deg)',
          },
        }}
        data-sm="advanced-button-input"
      >
        <Typography fontWeight={600} ml={'10px'}>
          Advanced
        </Typography>
      </AccordionSummary>

      <AccordionDetails sx={{ borderRadius: '32px' }}>{children}</AccordionDetails>
    </Accordion>
  );
};
